// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageHeader[data-v-e1c160d2]{padding:1em;color:var(--white);background-color:var(--primary);display:flex;gap:1rem}.PageHeader .title[data-v-e1c160d2]{text-transform:uppercase;color:var(--white)}.PageHeader .subtitle[data-v-e1c160d2]{font-size:.8rem;font-style:italic;color:var(--white)}.PageHeader .actions[data-v-e1c160d2]{display:flex;align-items:center;gap:.5rem}", ""]);
// Exports
module.exports = exports;
